import React, { useEffect, useRef, forwardRef } from "react";
import styles from "./searchbar.module.css";
import SearchIcon from "../../Assets/images/search.svg";

const SearchBar = forwardRef(({
	placeholder,
	value,
	onChange,
	onKeyDown,
	onFocus,
	searchBarClassName,
	className,
	iconClassName,
}, ref) => {

	return (
		<div className={`${styles.searchBar} ${searchBarClassName}`}>
			<div className={`${styles.searchIcon} ${iconClassName}`}>
				<img src={SearchIcon} alt="search" />
			</div>
			<input
				ref={ref}
				type="search"
				placeholder={placeholder}
				value={value}
				onChange={onChange}
				onKeyDown={onKeyDown}
				onFocus={onFocus}
				className={`form-control ${className}`}
			/>
		</div>
	);
});

SearchBar.displayName = 'SearchBar';

export default SearchBar;
